import {
  FETCH_DASHBOARD_DATA_REQUEST,
  FETCH_DASHBOARD_DATA_SUCCESS,
  FETCH_DASHBOARD_DATA_FAILURE,
  FETCH_OEM_PARTNERS_REQUEST,
  FETCH_OEM_PARTNERS_SUCCESS,
  FETCH_OEM_PARTNERS_FAILURE,
  SET_SELECTED_OEM_ID,
  CLEAR_DASHBOARD_DATA,
  CLEAR_DASHBOARD_ERROR
} from '../constants/dashboardConstants';

export const fetchDashboardDataRequest = (almataId, oemId = '') => ({
  type: FETCH_DASHBOARD_DATA_REQUEST,
  payload: { almataId, oemId }
});

export const fetchDashboardDataSuccess = (data) => ({
  type: FETCH_DASHBOARD_DATA_SUCCESS,
  payload: data
});

export const fetchDashboardDataFailure = (error) => ({
  type: FETCH_DASHBOARD_DATA_FAILURE,
  payload: error
});

export const fetchOemPartnersRequest = (almataId) => ({
  type: FETCH_OEM_PARTNERS_REQUEST,
  payload: almataId
});

export const fetchOemPartnersSuccess = (data) => ({
  type: FETCH_OEM_PARTNERS_SUCCESS,
  payload: data
});

export const fetchOemPartnersFailure = (error) => ({
  type: FETCH_OEM_PARTNERS_FAILURE,
  payload: error
});

export const setSelectedOemId = (oemId) => ({
  type: SET_SELECTED_OEM_ID,
  payload: oemId
});

export const clearDashboardData = () => ({
  type: CLEAR_DASHBOARD_DATA
});

export const clearDashboardError = () => ({
  type: CLEAR_DASHBOARD_ERROR
});